import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/Bundles/localization"

import BundleInfoUI from "@/components/MultiFinshProductBundle/ui/BundleInfoUI"
import ColorFinishSelectorUI from "@/components/MultiFinshProductBundle/ui/ColorFinishSelectorUI"

const BundleInfo = props => {
  const { bundlePdpData = {} } = props || {}
  const { pdpDetails = {} } = bundlePdpData

  const { t } = useTranslation("common")
  const staticTexts = getTranslations(t)

  return (
    <div className="multi-bundle-info">
      <BundleInfoUI
        {...props}
        pdpDetails={pdpDetails}
        staticTexts={staticTexts}
      />
      <ColorFinishSelectorUI {...props} staticTexts={staticTexts} />
    </div>
  )
}

export default BundleInfo
